import { Pipe, PipeTransform } from '@angular/core';

import { RouteHelper } from '@helper/route-paths';

@Pipe({ name: 'eventLink', standalone: true })
export class EventLinkPipe implements PipeTransform {
  transform(eventId: string, bigId: string): string {
    return `/${RouteHelper.salesEvent(eventId, bigId)}`;
  }
}
